import React from 'react';

import { Button, Grid, makeStyles, Typography } from '@material-ui/core';
import moment from 'moment';

import Table from '../common/Table';

const useStyles = makeStyles((theme) => {
  return {
    fieldTitle: {
      color: '#172B4D',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '16px',
      marginBottom: '1rem',
    },
    fieldValue: {
      color: '#172B4D',
      fontSize: '0.875rem',
      fontWeight: 'normal',
      lineHeight: '21px',
    },
    table: {
      maxWidth: '100%',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  };
});

export default ({ details, onUpgrade, onCancelPlan }) => {
  const classes = useStyles();
  const fields = [
    {
      title: 'My current plan',
      value: (
        <span style={{ textTransform: 'capitalize' }} className={classes.fieldValue}>
          {details.userPlan.name}
        </span>
      ),
    },
    {
      title: 'Storage',
      value: (
        <span
          className={classes.fieldValue}
          style={{
            color: details.userPlan.studyCount < details.userPlan.maxStudy || details.userPlan.maxStudy === -1 ? '#388E3C' : '#B12A2A',
          }}>{`${details.userPlan.studyCount}${details.userPlan.maxStudy !== -1 ? `/${details.userPlan.maxStudy}` : ''} Used`}</span>
      ),
    },
    {
      title: 'Expiration Date',
      value: (
        <span className={classes.fieldValue} style={{ color: new Date(details.userPlan.expiredAt) > new Date() ? '#388E3C' : '#B12A2A' }}>
          {moment(details.userPlan.expiredAt).format('MM/DD/YYYY')}
        </span>
      ),
    },
  ];

  const renderFields = () => {
    return fields.map((field) => {
      return (
        <Grid item xs={3} container key={field.title}>
          <Grid item xs={12}>
            <Typography className={classes.fieldTitle}> {field.title} </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography className={classes.fieldValue}> {field.value}</Typography>
          </Grid>
        </Grid>
      );
    });
  };

  const columns = fields.map((e) => ({ label: e.title, name: e.title }));
  const info = {};
  fields.forEach((e) => {
    info[e.title] = e.value;
  });

  return (
    <Grid>
      <Grid item container xs={12}>
        <Grid item xs={12}>
          <Typography className="secondary-header mb-1">My Current Plan</Typography>
        </Grid>
        <Grid item container xs={12} md={10}>
          <Table columns={columns} data={[info]} className={classes.table} options={{ isRowSelectable: () => false }} />
        </Grid>
        <Grid item xs={12} className="mt-2">
          {details?.userPlan?.maxStudy !== -1 && (
            <Button variant="contained" style={{ width: '155px' }} className="mr-1" color="primary" onClick={onUpgrade}>
              Upgrade my plan
            </Button>
          )}
          {!details?.userPlan?.cancelled && (
            <Button variant="contained" style={{ width: '155px' }} color="primary" onClick={onCancelPlan}>
              Cancel my plan
            </Button>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
